export const permissionsOld = [
    {
        path:"/user_management",
        name:"用户管理",
        icon:"/static/images/suspects.png"
    },{
        path:"/detect_subject_management",
        name:"检测项目管理",
        icon:"/static/images/suspects.png"
      }
]
export const permissions = [
  {
    title:'user_management',
    name:'用户管理',
    children:[
      {title:'user_management',name:'用户管理'}
    ]
  },{
    title:'detect_subject_management',
    name:'检测项目管理',
    children:[
      {title:'detect_subject_management',name:'检测项目管理'}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/service/permissions.js